import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { LoadSet } from '@paragon/contract-library';
import { forceArray } from '@paragon/utilities';

export interface LoadSetStore {
  [key: string]: LoadSet;
}

const initialState: Readonly<LoadSetStore> = {};

const loadSetsSlice = createSlice({
  name: 'loadSets',
  initialState,
  reducers: {
    setLoadSets: (state, action: PayloadAction<LoadSet | readonly LoadSet[]>) => {
      const loadSets = forceArray(action.payload);
      for (const loadSet of loadSets) {
        state[loadSet.guid] = castDraft(loadSet);
      }
    },
  },
});

export const { setLoadSets } = loadSetsSlice.actions;
export const loadSets = loadSetsSlice.reducer;
